module.exports = __webpack_public_path__ + "img/fondo_juegos.2e919ea9.jpg";